<template>
  <!--------------------------------------
    This component is a general wrapper for page blocks, with default top and bottom padding to separate blocks and optional width and side padding customization.<template>
  ---------------------------------------->
  <div class="block">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'Block',

  props: {
    maxWidth: { type: String, required: false },
    sidePaddingRem: { type: String, required: false }
  },

  mounted () {
    let wrappers = document.getElementsByClassName('block')

    if (this.maxWidth) {
      for (let i=0; i < wrappers.length; i++) {
        wrappers[i].style.maxWidth = this.maxWidth + 'px'
      }
    }

    if (this.sidePaddingRem) {
      for (let i=0; i < wrappers.length; i++) {
        wrappers[i].style.paddingLeft = this.sidePaddingRem + 'rem'
        wrappers[i].style.paddingRight = this.sidePaddingRem + 'rem'
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';

.block {
  padding: 1rem 0 2rem 0;
  margin: 0 auto;

  &:last-of-type {
    margin-bottom: 3rem;
  }
}
@media screen and (max-width: 1300px) {
  .block {
    padding: 1rem 0.25rem;
  }
}
@media screen and (max-width: $tablet) {
  .block {
    padding-left: 0.0625rem;
    padding-right: 0.0625rem;
  }
}

</style>